/* KLARHEIT 2027 — cart drawer enhancements.
   Delegated listeners so they survive Dawn's section re-renders. */
(function () {
  document.addEventListener('click', function (e) {
    // Staffel-Zeile: round quantity up to the next full tier
    var tier = e.target.closest('[data-k27-tier-add]');
    if (tier) {
      e.preventDefault();
      var line = tier.getAttribute('data-line');
      var input = document.getElementById('Drawer-quantity-' + line);
      if (input) {
        input.value = tier.getAttribute('data-target-qty');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Rabattcode: toggle input row
    var toggle = e.target.closest('[data-k27-code-toggle]');
    if (toggle) {
      e.preventDefault();
      var row = toggle.parentNode.querySelector('.code-row');
      if (row) {
        row.hidden = !row.hidden;
        if (!row.hidden) {
          var input = row.querySelector('input');
          if (input) input.focus();
        }
      }
      return;
    }

    // Rabattcode: apply via Shopify discount URL, then on to checkout
    var apply = e.target.closest('[data-k27-code-apply]');
    if (apply) {
      e.preventDefault();
      var codeInput = apply.parentNode.querySelector('[data-k27-code-input]');
      var code = codeInput ? codeInput.value.trim() : '';
      if (code) {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      }
    }
  });

  // Enter key in code input applies
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-k27-code-input]')) {
      e.preventDefault();
      var btn = e.target.parentNode.querySelector('[data-k27-code-apply]');
      if (btn) btn.click();
    }
  });
})();
